export default ({
  labelFont = 'head'
}, {
  treatments
}) => ({
  label: {
    ...treatments[labelFont]
  },
  item: {
    '& strong': {
      opacity: 0.75
    }
  }
})



// WEBPACK FOOTER //
// ./components/slices/DonationTicker/styles.js